function ResizeCategoryDrillDownWrapper() {
    var containerWidth = 1014;
    var windowWidth = $(window).width();
    if (windowWidth < containerWidth) {
        containerWidth = windowWidth;
    }

    var categoryWidth = $('.category-item').outerWidth() + 15;
    var numberOfCategoriesThatWillFit = Math.floor(containerWidth / categoryWidth);
    var newCategoryWrapperWidth = numberOfCategoriesThatWillFit * categoryWidth;
    $('#categories').css('width', newCategoryWrapperWidth);
}


$(document).ready(function () {

    $('.cat-block').unbind('mouseenter');

    //// RESIZE CATEGORY DRILL DOWN WRAPPER
    ResizeCategoryDrillDownWrapper();

    $(window).resize(function () {
        ResizeCategoryDrillDownWrapper();
    });

    if ($('#main').length > 0) {
        $('#SMCLoadingGif').hide();
        $('#main').removeAttr('style');
    }

    if ($('#table-responsive').length > 0) {

        var DescHTML = $('.description-text').html();

        var DescFinal = DescHTML.replace('&lt;p&gt;', '').replace('&lt;/p&gt;', '');
        $('.description-text').html(DescFinal);
        $('#PartMakerWrapper').show();
    }

    $('#MobileShowHideDesc').click(function () {
        if ($("#DiscriptionWrapper").is(":hidden")) {
            $("#DiscriptionWrapper").slideDown("fast");
            $("#MobileShowHideDesc").text('Hide Description');
            return false;
        }

        else {
            $("#DiscriptionWrapper").slideUp("fast");
            $("#MobileShowHideDesc").text('Show Description');
            return false;
        }
    });

    //WRAP TEXT IN <P> IF NOT ALREADY WRAPPED

    $('.category-item').each(function () {
        var CatTxt = $(this).find('.cat-content').text();

        if (CatTxt.match(/[a-z]/i)) {
            $(this).find('.cat-content').not(':has(p)').wrapInner('<p></p>');
            $(this).addClass("SecondLevelCats");
            $(this).addClass("expandable");
        }
    });


    //MOVE COPY CONFIG NUMBER
    $('.clipboard').insertAfter('.large');


    //ADD 'SEARCH FOR PART NUMBER' BUTTON
    setTimeout(
        function () {
            $('#cpn_state').prev('td').hide();
            $('#form table > tbody > tr').addClass('PartsSections');
            $('#cpn_partnumber').parent().append('<div class="search-container"><a class="SearchFor Unclickable" href="#">Click to Order &#x25BA;</a></div>');
        }, 200);



    //GREY OUT BUTTON IF OPTIONS ARE BLANK
    $('.option-selection select').change(function () {
        var partStatus = $('#table-responsive').find('#cpn_state span').text();

        if (partStatus == 'Complete') {
            $('#table-responsive').find('.SearchFor').removeClass('Unclickable');

            //GET CONFIGURATION NUMBER FOR ISR
            var searchPartNum = "";
            $('#cpn_partnumber > table td').each(function () {
                searchPartNum += $(this).text().trim()
            });
            $('.SearchFor').attr('href', '/search?searchTerm=' + searchPartNum);

        }
        else {
            $('#table-responsive').find('.SearchFor').addClass('Unclickable');
        }
    });

    $('.option-label img').attr('src', '../img/HelpHere.png');

    $('.MobileToggleCat').click(function () {
        $(this).parent().find('.MobileToggleInfo').slideToggle();
    });

});

let categoryTrail = JSON.parse(sessionStorage.getItem('categoryTrail')) || [];

  function updateBreadcrumb() {
    const breadcrumbEl = document.querySelector('#breadcrumb');
    breadcrumbEl.innerHTML = '';

    // Always show Home link
    const homeLink = document.createElement('a');
    homeLink.href = 'javascript:void(0)';
    homeLink.textContent = 'Home';

    homeLink.addEventListener('click', () => {
      categoryTrail = []; // reset trail
      sessionStorage.setItem('categoryTrail', JSON.stringify(categoryTrail));
      window.location.reload();
    });

    breadcrumbEl.appendChild(homeLink);

    if (categoryTrail.length > 0) {
      breadcrumbEl.appendChild(document.createTextNode(' > '));
    }

    // Add dynamic categories
    categoryTrail.forEach((cat, index) => {
      const link = document.createElement('a');
      link.href = 'javascript:void(0)';
      link.textContent = cat.name;
      link.dataset.handle = cat.handle;

      link.addEventListener('click', (e) => {
        categoryTrail = categoryTrail.slice(0, index + 1);
        sessionStorage.setItem('categoryTrail', JSON.stringify(categoryTrail));
        fetchSubcategory(cat.handle, e.currentTarget.innerText || '', false);
      });

      breadcrumbEl.appendChild(link);

      if (index < categoryTrail.length - 1) {
        breadcrumbEl.appendChild(document.createTextNode(' > '));
      }
    });
  }

// updateBreadcrumb();